module.exports = __webpack_public_path__ + "static/media/29.fc5881d3.jpg";